import { EntityLegalTypeEnum } from "gen/model/entityLegalTypeEnum";
import { useTranslation } from "react-i18next";
import { FormSelect } from "shared/components/input/select/Select";
import { SelectElement } from "shared/components/input/select/SelectOption";
import { enumKeys } from "shared/utils/EnumUtils";

export const LegalTypeFormSelect: React.FC = () => {
  const { t } = useTranslation(["entity", "enums"]);
  const fundEntityLegalTypeElements = enumKeys(
    EntityLegalTypeEnum,
  ).map<SelectElement>((legalType) => ({
    value: legalType,
    rich_value: t(`enums:EntityLegalTypeEnum.${legalType}`),
  }));

  return (
    <FormSelect
      name="legal_type"
      title={t("entity:legalType")}
      elements={fundEntityLegalTypeElements}
    />
  );
};
